import { apiClient } from './apiClient';

export type CommunicationRole = {
  id: string;
  name: string;
  kind: string;
  sortOrder: number;
  isSystem: boolean;
};

export async function listCommunicationRoles(): Promise<CommunicationRole[]> {
  const response = await apiClient.get<CommunicationRole[]>('/v1/core/communication-roles');
  return response.data;
}

export async function createCommunicationRole(name: string): Promise<CommunicationRole> {
  const response = await apiClient.post<CommunicationRole>('/v1/core/communication-roles', { name });
  return response.data;
}

export async function updateCommunicationRole(id: string, name: string): Promise<CommunicationRole> {
  const response = await apiClient.put<CommunicationRole>(`/v1/core/communication-roles/${id}`, {
    name,
  });
  return response.data;
}

export async function deleteCommunicationRole(id: string): Promise<void> {
  await apiClient.delete(`/v1/core/communication-roles/${id}`);
}
